import {chatReducer} from "./../app/chat/~store/reducer";

export const reducers = {
    chat: chatReducer
};
